/*
  Reviews scroller: drifts left on its own; hover (or touch) hands control to the visitor.
  Trackpad swipe, mouse drag, and touch swipe all scroll it. The cards are rendered three times;
  the row stays around the middle copy and jumps by exactly one set at the edges, so it loops both ways.
*/
(function () {
  function init(viewport) {
    if (viewport.dataset.rcReady) return;
    viewport.dataset.rcReady = 'true';

    var track = viewport.querySelector('.rc-reviews__track');
    var firstDupe = track.querySelector('.rc-reviews__card--dupe');
    if (!firstDupe) return;

    // Reduced motion: the CSS shows one plain swipeable copy, nothing to drive
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var seconds = parseFloat(viewport.dataset.secondsPerCard) || 9;
    var hovering = false;
    var touching = false;
    var dragging = false;
    var inView = false;
    var touchTimer = null;
    var pos = 0;
    var last = 0;

    function loopWidth() {
      return firstDupe.offsetLeft - track.firstElementChild.offsetLeft;
    }

    function cardCount() {
      return track.querySelectorAll('.rc-reviews__card:not(.rc-reviews__card--dupe)').length;
    }

    function userControlled() {
      return hovering || touching || dragging;
    }

    // Keep the scroll position between half a set and a set and a half
    function wrap() {
      var w = loopWidth();
      if (w <= 0) return;
      if (viewport.scrollLeft >= w * 1.5) viewport.scrollLeft -= w;
      else if (viewport.scrollLeft < w * 0.5) viewport.scrollLeft += w;
    }

    function tick(now) {
      var dt = last ? Math.min((now - last) / 1000, 0.1) : 0;
      last = now;
      if (!userControlled() && inView && !document.hidden) {
        var w = loopWidth();
        pos += (w / cardCount() / seconds) * dt;
        if (pos >= w * 1.5) pos -= w;
        viewport.scrollLeft = pos;
      }
      requestAnimationFrame(tick);
    }

    viewport.addEventListener('scroll', function () {
      // Only track the visitor's scrolling; the drift keeps its own sub-pixel position
      if (!userControlled()) return;
      wrap();
      pos = viewport.scrollLeft;
    }, { passive: true });

    viewport.addEventListener('mouseenter', function () { hovering = true; });
    viewport.addEventListener('mouseleave', function () { hovering = false; });
    viewport.addEventListener('focusin', function () { hovering = true; });
    viewport.addEventListener('focusout', function () { hovering = false; });

    viewport.addEventListener('touchstart', function () {
      touching = true;
      clearTimeout(touchTimer);
    }, { passive: true });
    viewport.addEventListener('touchend', function () {
      clearTimeout(touchTimer);
      touchTimer = setTimeout(function () { touching = false; }, 3000);
    }, { passive: true });

    // Mouse drag (touch scrolls natively)
    var startX = 0;
    var startScroll = 0;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      startX = e.clientX;
      startScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(e.pointerId);
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      viewport.scrollLeft = startScroll - (e.clientX - startX);
      wrap();
      if (viewport.scrollLeft !== startScroll - (e.clientX - startX)) {
        // Wrapped mid-drag: rebase so the drag stays smooth
        startScroll = viewport.scrollLeft + (e.clientX - startX);
      }
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      pos = viewport.scrollLeft;
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
      }).observe(viewport);
    } else {
      inView = true;
    }

    pos = loopWidth();
    viewport.scrollLeft = pos;
    requestAnimationFrame(tick);
  }

  function initAll() {
    document.querySelectorAll('.rc-reviews__viewport').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
